import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectButtonModule, SharedModule } from 'primeng';
import { SelectItem } from 'primeng/api';
import { VmeCommonModule } from '../../../vme-common.module';
import { RiskManagementView } from '../../../enums/supplier-risk-management/risk-management-view.enum';

/**
 * Top level switcher between the risk view (suppliers with work scheduled today), the unscheduled
 * tasks view (live work with no driver schedule set at all) and, for risk management admins, the
 * assignment audit trail.
 */
@Component({
  selector: 'risk-management-view-tabs',
  standalone: true,
  imports: [CommonModule, SelectButtonModule, SharedModule, VmeCommonModule],
  templateUrl: './risk-management-view-tabs.component.html',
  styleUrls: ['./risk-management-view-tabs.component.scss'],
})
export class RiskManagementViewTabsComponent implements OnChanges {
  @Input() selectedView: RiskManagementView = RiskManagementView.Risks;
  @Input() unscheduledCount: number = null;
  @Input() loadingCount: boolean = false;

  /**
   * The assignment audit trail exposes every user's activity, so the tab is only offered to risk
   * management admins — the same users the endpoints behind it are restricted to.
   */
  @Input() isRiskManagementAdmin: boolean = false;

  @Output() viewChanged = new EventEmitter<RiskManagementView>();

  public viewOptions: SelectItem[] = [];

  constructor() {
    this.buildViewOptions();
  }

  ngOnChanges() {
    // The admin flag is resolved asynchronously, so the options are rebuilt when it arrives.
    this.buildViewOptions();
  }

  private buildViewOptions() {
    const options: SelectItem[] = [
      {
        label: 'Risks',
        value: RiskManagementView.Risks,
      },
      {
        label: 'No Schedule Set',
        value: RiskManagementView.UnscheduledTasks,
      },
    ];

    if (this.isRiskManagementAdmin) {
      options.push({
        label: 'Assignment History',
        value: RiskManagementView.AssignmentHistory,
      });
    }

    this.viewOptions = options;
  }

  protected readonly RiskManagementView = RiskManagementView;
}
